<template>
  <Header />

  <FriendEdit :friend="friend" />

  <Footer />
</template>

<script>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import FriendEdit from "@/components/FriendEdit.vue";

export default {
  name: "PeopleView",
  components: {
    Header,
    Footer, 
    FriendEdit,
  },
  created() {
    if (!this.$store.state.friendMap.find(item => item.id === this.$route.params.id)) {
      this.$router.push({ name: 'People' })
    }
  },
  data() {
    return {
      friend: this.$store.state.friendMap.find(item => item.id === this.$route.params.id),
    }
  },
};
</script>
